package com.example.mystybag.appCore.expected

import com.example.mystybag.appCore.model.pages.StatementRowDisplay

actual object StatementsPdfExporter {
    actual fun exportAndShareStatementsPdf(
        documentTitle: String,
        totalAmount: String,
        reportPeriod: String,
        currency: String,
        rows: List<StatementRowDisplay>
    ): Boolean = false
}
